import Header from "@/reusable_sections/Header";
import GalleryIntro from "./sections/GalleryIntro";
import PortfolioGrid from "./sections/PortfolioGrid";
import ShareExperience from "./sections/ShareExperience";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
export default function ProjectGalleryPage() {
  return <div className="min-h-screen bg-background text-foreground">
      <Header />
      <GalleryIntro />
      <PortfolioGrid />
      <ShareExperience />
      <CtaBand title="Like What You See?" text="Book a visit and tell us about your project. Prefer to talk? Call us." />
      <Footer />
    </div>;
}